import { PropsWithChildren } from 'react'
import cx from 'classnames'
import styles from './IOPanel.module.css'

export interface IOPanelProps {
  /** Additional CSS class */
  className?: string
}

/**
 * Lays out a row of IOJack sockets.
 * Use IOPanelDivider between groups of jacks.
 */
export function IOPanel({
  children,
  className,
}: PropsWithChildren<IOPanelProps>) {
  return (
    <div className={cx(styles.IOPanel, className)}>
      {children}
    </div>
  )
}

/**
 * A vertical rule separating groups of jacks,
 * e.g. inputs from outputs.
 */
export function IOPanelDivider() {
  return (
    <div
      className={styles.IOPanel__divider}
      aria-hidden="true"
    />
  )
}
